import { createGetEndpoint } from '@sonar-software/sonar-http';

export type GetSonarObjectProfilesRequest = {
	sonarObjectId: number;
};

export type GetSonarObjectProfilesResponse = Array<{ id: number; name: string; }>;

export const getSonarObjectProfiles = createGetEndpoint<
	GetSonarObjectProfilesRequest,
	GetSonarObjectProfilesResponse
>(({ sonarObjectId }) => `/api/v3/salesforce/profiles/${sonarObjectId}`);
